import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { INewOrderModel, IOrderDetailsModel } from '@apps-common/types/management/order'

export const createOrder = async (model: INewOrderModel): Promise<IOrderDetailsModel> =>
  axios.post(`/management/order/addorder`, model).then((res) => res?.data?.data)

type Props = {
  model: INewOrderModel
}

export const useManagementCreateOrder = (notify?: boolean, onSuccess?: (data: IOrderDetailsModel) => void) =>
  useMutation({
    mutationKey: ['createOrder'],
    mutationFn: ({ model }: Props) => createOrder(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created order.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create order, please try again.')
      }
    },
    throwOnError: false
  })
